import { render } from "./ImproveData.vue?vue&type=template&id=0b4b8fd6&scoped=true"
import script from "./ImproveData.vue?vue&type=script&lang=js"
export * from "./ImproveData.vue?vue&type=script&lang=js"

import "./ImproveData.vue?vue&type=style&index=0&id=0b4b8fd6&scoped=true&lang=css"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4b8fd6"]])

export default __exports__